FN.popupConfig.addPopupConfig({
    'id': 'fn-popup_incentive_design-manifesto',
    'type': 'modal',
    'active': true,
    'pagePaths': ['.*'],
    'display': {
        'event': 'onClick',
        'selector': '.button-wallpaper',
        'showOnlyOnce': false
    },
    'content': [
        {
            'type': 'newsletter-signup',
            'text': '<h2 class="fn-popup__text--headline">Download the Wallpaper<span class="fn-popup__text--tag">Free</span></h2><p class="fn-popup__text--subline">Get a set of awesome wallpapers for your desktop!</p>',
            'action-button': 'Get the Wallpaper',
            'signup-medium': 'tower-blog',
            'signup-URI': 'fn-popup_incentive_design-manifesto',
            'signup-form': 7,
            'tags': [
                {
                    'id': 'tower_newsletter',
                    'label': "Yes, send me the wallpaper and sign me up for the Tower newsletter. It's free, it's sent infrequently, you can unsubscribe any time — and it's loved by over <b>100,000 developers & designers</b>!",
                    'default': false,
                    'hidden': false,
                    'required': true,
                    'collectConsent': true
                },
                {
                    'id': 'incentive_design-manifesto',
                    'label': '',
                    'default': true,
                    'hidden': true,
                    'collectConsent': false
                }
            ],
            'consent': [
                {
                    'id': 'legal',
                    'required': true,
                    'text': 'I have read and accept the <a href="' + FN.siteURL('tower', 'legal/privacy-policy') + '" target="_blank">Privacy Policy</a>. <br/>I understand that I can unsubscribe at any time.'
                }
            ]
        },
        { 'type': 'tweet',
          'text': '<h2 class="fn-popup__text--headline">Thanks!</h2><span class="fn-popup__text--subline">Please check your inbox for our confirmation email.<br><br>And for a chance to <u>win one of the posters</u>, simply help us spread the word via Twitter!</span>',
          'action-button': 'Share on Twitter',
          'footer': '<br>Follow <a href="https://x.com/gittower" target="_blank">@gittower</a> to be notified if you win!',
          'tweet': {
            'platform': 'twitter',
            'url': 'https://bit.ly/design-manifesto',
            'text': '"Design Every Day" - The Design Manifesto by @gittower. #designmanifesto '
          }
        }
    ]
});

$(document).ready(function () {
    // Analytics
    var micrositeAnalyticsEvents = [
        // Page links
        {
            'config': {
                'selector': '.button-poster.analytics--click',
                'waitBeforeDefault': true
            },
            'event':  {
                'eventCategory': 'page-interaction',
                'eventAction': 'landing-page',
                'eventLabelSuffix': 'design-manifesto/stuff-store'
            }
        },
        {
            'config': {
                'selector': '.some-questions.analytics--click',
                'waitBeforeDefault': true
            }
        },

        // Social media buttons
        {
            'config': {
                'selector': '.some-twitter.analytics--click'
            },
            'event':  {
                'eventCategory': 'social',
                'eventAction': 'share',
                'eventLabelSuffix': 'design-manifesto/twitter'
            }
        },
        {
            'config': {
                'selector': '.some-facebook.analytics--click'
            },
            'event':  {
                'eventCategory': 'social',
                'eventAction': 'share',
                'eventLabelSuffix': 'design-manifesto/facebook'
            }
        },
        {
            'config': {
                'selector': '.some-linkedin.analytics--click'
            },
            'event':  {
                'eventCategory': 'social',
                'eventAction': 'share',
                'eventLabelSuffix': 'design-manifesto/linkedin'
            }
        }
    ];
    FN.analytics.addConfiguredEvents(micrositeAnalyticsEvents);

    // Prefill source[OS] value in newsletter forms
    if($('input[name="signup[OS]"]').length > 0){
        $('input[name="signup[OS]"]').val(FN.helpers.platform());
    }

    // Set up smooth scroll navigation between sections
    $.scrollIt();

    // Set up scroll effects
    AOS.init({
        easing: 'ease-in-out-cubic',
        duration: '600'
    });

    // A bit of a hack to make the poster in the first section fly up as soon as
    // the "scroll" button is clicked — we trigger the mirror AOS animation
    // early.
    var scrollButton = document.querySelector('.scroll');
    var poster = document.querySelector('.the-design-manifesto .poster');
    scrollButton.addEventListener('click', function () {
        poster.classList.remove('aos-animate');
    });
});
